import { Component, OnInit } from '@angular/core';
import { SitesHttpService } from './shared/services/http/sites-http.service';
import { NavBarTopComponent } from './shared/components/nav-bar-top/nav-bar-top.component';
import { CurrentStateService } from './core/services/current-state.service';
import { Site } from './shared/models/site';
import { LocalStorageService } from './shared/services/utilities/local-storage.service';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { NavBarLeftComponent } from './shared/components/nav-bar-left/nav-bar-left.component';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from "@angular/material/icon";
import { MENU_OPTIONS } from '@shared/constants/left-menu-option';
import { filter } from 'rxjs/operators';




@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    NavBarLeftComponent,
    NavBarTopComponent,
    RouterModule,
    TranslateModule,
    MatIconModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ]
})
export class AppComponent implements OnInit {
  title = 'Vibrations platform';
  isSettingsOpen: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private sitesService: SitesHttpService,
    protected currentStateService: CurrentStateService,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
    private router: Router
  ) {
    this.translate.addLangs(['en', 'fr', 'es']);
    this.translate.setDefaultLang('en');

    const savedLang = localStorage.getItem('lastLang') || 'en';
    this.translate.use(savedLang);
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.unsubscribe$)
    ).subscribe((event: NavigationEnd) => {
      this.setMenuBasedOnRoute(event.url);
    });
    this.setMenuBasedOnRoute(this.router.url);

    this.currentStateService.setShowLoading(true);
      this.sitesService.getSitesAcitve().pipe(
        takeUntil(this.unsubscribe$)
      ).subscribe({
        next: (sites: Site[]) => {
          if (this.localStorageService.hasItem('currentSiteID')) {
            const siteID = this.localStorageService.getItem('currentSiteID');
            const currentSite = sites.find(site => site.siteId === siteID);
            if (currentSite) {
              this.currentStateService.setCurrentSite(currentSite);
            }
          } else {
            this.currentStateService.setCurrentSite(sites[0]);
          }

          this.currentStateService.setShowLoading(false);
        },
        error: () => { },
      });   
  }

  private setMenuBasedOnRoute(currentRoute: string): void {
    let menuToSet = MENU_OPTIONS.CONTROL_POINT;
    if (currentRoute.includes('/devices')) {
      menuToSet = MENU_OPTIONS.DEVICES;
    } else if (currentRoute.includes('/monitoring')) {
      menuToSet = MENU_OPTIONS.MONITORING;
    } else if (currentRoute.includes('/timeline')) {
      menuToSet = MENU_OPTIONS.TIMELINE;
    } else if (currentRoute.includes('/event')) {
      menuToSet = MENU_OPTIONS.EVENT;
    } else if (currentRoute === '/control-point' || currentRoute === '/') {
      menuToSet = MENU_OPTIONS.CONTROL_POINT;
    }
    else{
      return;
    }
    this.currentStateService.setCurrentMenu(menuToSet);
    this.localStorageService.setItem('currentMenu', menuToSet);
  }

  shouldShowNavBarTop(): boolean {
    return !this.router.url.includes('detail') && !this.router.url.includes('settings');
  }
  shouldShowLeftBar(): boolean {
    return !this.router.url.includes('settings');
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}